import { createFileRoute } from '@tanstack/react-router'

import { AuthSignInPage } from '@/features/auth/pages'
import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'

export const Route = createFileRoute('/_event/auth/sign-in')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  component: TenantAuthSignInRoute
})

function TenantAuthSignInRoute() {
  const tenant = useTenantOptional()

  return (
    <AuthSignInPage digitalProductId={tenant?.digitalProductId ?? undefined} />
  )
}
